import styled from 'styled-components';
import { getColorShade, getSizeBy } from '../../../src/styled/utils';
import { Heading4, Subtitle2Styles } from '../typography';
export const Title = styled(Heading4) `
  padding: ${getSizeBy(3)} ${getSizeBy(4)};
  color: ${getColorShade('onSurface', 'highEmphasis')};
  text-align: left;
`;
export const FallbackWrapper = styled.div `
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: center;
`;
export const FallbackContainer = styled.div `
  position: relative;
  top: calc(50% - 15px);
  width: 100%;
  height: 100%;
  transform: ${(props) => props.withTitle ? `translate(0, calc(-12% - 44px))` : `translate(0, -12%)`};
`;
export const FallbackContent = styled.div `
  ${Subtitle2Styles};
  margin-top: 16px;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
`;
